import BsDateField from './index.vue'
export default BsDateField